import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="py-8 md:py-16 bg-gray-900 text-gray-50" data-id="element-25" data-mp="pm29dppob3dv">
      <div className="container mx-auto px-4 md:px-6" data-id="element-26" data-mp="aua6weaz9jtk">
        <div className="text-center mb-5 md:mb-10" data-id="element-27" data-mp="ftwlar2jl63y">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-teal-600 text-white text-[10px] md:text-xs font-bold mb-2 md:mb-3" data-id="element-28" data-mp="fsljgwsnq8fh">
            <Gift className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-29" data-mp="5vqhu5137rwz" />
            KIT DE BLINDAJE · SIN COSTO ADICIONAL
          </div>
          <h2 className="font-display text-xl md:text-3xl font-extrabold tracking-tight mb-1.5 md:mb-2" data-id="element-30" data-mp="3o2n3bwrgy2il">
            Además, recibes 5 Bonus Exclusivos
          </h2>
          <p className="text-xs md:text-sm text-gray-400 max-w-xl mx-auto leading-snug" data-id="element-31" data-mp="1mai1ntk63quo">
            5 herramientas de ejecución inmediata para blindar tus decisiones
            desde el primer mes.
          </p>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-5 gap-2.5 md:gap-4 max-w-6xl mx-auto" data-id="element-32" data-mp="3ideke10bxu2r">
          {bonuses.map((bonus, index) => <motion.li key={bonus.number} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} whileHover={{
          y: -4
        }} className={`bg-gray-800 border border-gray-700 hover:border-teal-500/50 transition-colors rounded-xl p-3 md:p-4 flex flex-col ${index === 4 ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-33" data-mp="3df3d9y1f5xo8" data-mpi={index}>
              <div className="flex items-center justify-between mb-2 md:mb-3" data-id="element-34" data-mp="ns4bqd4poebe">
                <span className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-gray-700 flex items-center justify-center" data-id="element-35" data-mp="iqewelaghehi">
                  <bonus.icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-teal-400" data-id="element-36" data-mp="3cimwiot0yo74" />
                </span>
                <span className="font-display text-[9px] md:text-[10px] font-extrabold tracking-wide text-teal-400" data-id="element-37" data-mp="3hk3yyor5qipt">
                  BONUS #{bonus.number}
                </span>
              </div>
              <h3 className="font-display text-xs md:text-sm font-bold leading-snug mb-1" data-id="element-38" data-mp="3qglaht3foim3">
                {bonus.title}
              </h3>
              <p className="text-[11px] md:text-xs text-gray-400 leading-snug mb-3" data-id="element-39" data-mp="2xtihfghj1038">
                {bonus.description}
              </p>
              <span className="mt-auto inline-flex self-start items-center px-2 py-0.5 rounded-full bg-teal-600/15 text-teal-400 text-[9px] md:text-[10px] font-bold tracking-wide" data-id="element-40" data-mp="32rk225ulp7gt">
                INCLUIDO
              </span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}